<template>
  <section class="page-wrap">
    <UiPageHero
      eyebrow="Tài khoản"
      title="Đăng ký tài khoản mới"
      description="Tạo tài khoản người dùng và gán quyền truy cập theo khoa/phòng."
    />

    <form class="panel-pad max-w-4xl" @submit.prevent="submit">
      <div class="grid gap-4 md:grid-cols-2">
        <UiInput v-model="form.username" label="Tên đăng nhập" required />
        <UiInput
          v-model="form.password"
          label="Mật khẩu"
          type="password"
          required
        />
        <UiInput v-model="form.fullname" label="Họ tên" required />
        <UiInput v-model="form.phoneNumber" label="Số điện thoại" />
        <UiSelect v-model="form.permission" label="Quyền">
          <option value="user">Người dùng</option>
          <option value="admin">Quản trị viên</option>
        </UiSelect>
        <UiSelect v-model.number="form.idKhoaPhong" label="Khoa/phòng">
          <option :value="0">Chọn khoa/phòng</option>
          <option v-for="item in khoaPhong" :key="item.id" :value="item.id">
            {{ item.tenKhoaPhong }}
          </option>
        </UiSelect>
      </div>

      <div class="mt-5 flex flex-wrap items-center gap-3">
        <UiButton type="submit" icon="userAdd" :loading="loading" loading-text="Đang tạo...">
          Tạo tài khoản
        </UiButton>
        <UiButton to="/userlist" variant="secondary" icon="view">
          Danh sách tài khoản
        </UiButton>
      </div>
    </form>
  </section>
</template>

<script lang="ts">
import { onMounted, ref } from "vue";
import AuthRepository from "@/services/AuthRepository";
import QLTSRepository from "@/services/QLTSRepository";
import { Register } from "@/models/register";
import { KhoaPhong } from "@/models/khoaPhong";
import { getErrorMessage, useToast } from "@/utils/toast";

export default {
  setup() {
    const form = ref<Register>({
      username: "",
      password: "",
      fullname: "",
      permission: "user",
      idKhoaPhong: 0,
      phoneNumber: "",
      khoaPhong: "",
    });
    const khoaPhong = ref<KhoaPhong[]>([]);
    const loading = ref(false);
    const { showToast } = useToast();

    onMounted(() => {
      QLTSRepository.getListKhoaPhong().then((res) => {
        khoaPhong.value = res.data || [];
      });
    });

    const submit = () => {
      loading.value = true;
      AuthRepository.registerUser(form.value)
        .then(() => {
          showToast("Đã tạo tài khoản thành công.", "success");
          form.value = {
            ...form.value,
            username: "",
            password: "",
            fullname: "",
            phoneNumber: "",
          };
        })
        .catch((err) => {
          showToast(
            getErrorMessage(err, "Không tạo được tài khoản."),
            "error",
          );
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return { form, khoaPhong, loading, submit };
  },
};
</script>

